import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const ratingReviewsApi = createApi({
    reducerPath: "ratingReviewsApi",
    tagTypes: ["ratingReviews"],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: (build) => ({
        getAverageRating: build.query({
            query: (data) => ({
                url: api.ratingReviews.getAverageRating(),
                method: "GET",
                params: data,
            }),
            providesTags: ["ratingReviews"],
        }),
        getRatingReviews: build.query({
            query: ({...data}) => ({
                url: api.ratingReviews.getRatingReviews(),
                method: 'GET',
                params: data
            }),
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return [endpointName, queryArgs?.location_id]
            },
            merge: (currentCache, newItems, { arg }) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                return currentArg !== previousArg;
            },
        }),
        deleteReview: build.mutation({
            query: ({id}) => ({
                url: api.ratingReviews.deleteReview(id),
                method: 'DELETE',
            }),
            async onQueryStarted(patch, {dispatch, queryFulfilled}) {
                try {
                    await queryFulfilled
                    dispatch(
                        ratingReviewsApi.util.updateQueryData('getRatingReviews', patch, (draft) => {
                            const index = draft.findIndex((review) => review.id === patch.id);
                            if (index !== -1) {
                                draft.splice(index, 1)
                            } else {
                                console.warn('Review not found in cache')
                            }
                        })
                    );
                } catch (e) {
                    console.error('Delete failed:', e)
                }
            },
            invalidatesTags: ['ratingReviews']
        }),
    }),
});

export const { useGetAverageRatingQuery, useDeleteReviewMutation } = ratingReviewsApi;
